import * as api from '../../api/equityFinder/version';
import * as propertyApi from '../../api/equityFinder/property';
import { makeApiActionCreatorV3 } from '../utils';

export const VERSIONS_FETCH_START = 'VERSION/VERSIONS_FETCH_START';
export const VERSIONS_FETCH_SUCCESS = 'VERSION/VERSIONS_FETCH_SUCCESS';
export const VERSIONS_FETCH_ERROR = 'VERSION/VERSIONS_FETCH_ERROR';

export const VERSION_FETCH_START = 'VERSION/VERSION_FETCH_START';
export const VERSION_FETCH_SUCCESS = 'VERSION/VERSION_FETCH_SUCCESS';
export const VERSION_FETCH_ERROR = 'VERSION/VERSION_FETCH_ERROR';

export const VERSION_CREATE_START = 'VERSION/VERSION_CREATE_START';
export const VERSION_CREATE_SUCCESS = 'VERSION/VERSION_CREATE_SUCCESS';
export const VERSION_CREATE_ERROR = 'VERSION/VERSION_CREATE_ERROR';

export const VERSION_REMOVE_START = 'VERSION/VERSION_REMOVE_START';
export const VERSION_REMOVE_SUCCESS = 'VERSION/VERSION_REMOVE_SUCCESS';
export const VERSION_REMOVE_ERROR = 'VERSION/VERSION_REMOVE_ERROR';

export const VERSION_SET_ACTIVE_START = 'VERSION/VERSION_SET_ACTIVE_START';
export const VERSION_SET_ACTIVE_SUCCESS = 'VERSION/VERSION_SET_ACTIVE_SUCCESS';
export const VERSION_SET_ACTIVE_ERROR = 'VERSION/VERSION_SET_ACTIVE_ERROR';

export const VERSION_ADD_PROPERTY_START = 'VERSION/VERSION_ADD_PROPERTY_START';
export const VERSION_ADD_PROPERTY_SUCCESS =
  'VERSION/VERSION_ADD_PROPERTY_SUCCESS';
export const VERSION_ADD_PROPERTY_ERROR = 'VERSION/VERSION_ADD_PROPERTY_ERROR';

export const VERSION_COPY_PROPERTY_START =
  'VERSION/VERSION_COPY_PROPERTY_START';
export const VERSION_COPY_PROPERTY_SUCCESS =
  'VERSION/VERSION_COPY_PROPERTY_SUCCESS';
export const VERSION_COPY_PROPERTY_ERROR =
  'VERSION/VERSION_COPY_PROPERTY_ERROR';

export const VERSION_IMPORT_PROPERTY_START =
  'VERSION/VERSION_IMPORT_PROPERTY_START';
export const VERSION_IMPORT_PROPERTY_SUCCESS =
  'VERSION/VERSION_IMPORT_PROPERTY_SUCCESS';
export const VERSION_IMPORT_PROPERTY_ERROR =
  'VERSION/VERSION_IMPORT_PROPERTY_ERROR';

export const VERSION_REMOVE_PROPERTY_START =
  'VERSION/VERSION_REMOVE_PROPERTY_START';
export const VERSION_REMOVE_PROPERTY_SUCCESS =
  'VERSION/VERSION_REMOVE_PROPERTY_SUCCESS';
export const VERSION_REMOVE_PROPERTY_ERROR =
  'VERSION/VERSION_REMOVE_PROPERTY_ERROR';

export const VERSION_COMP_PROPERTY_SEARCH_START =
  'VERSION/VERSION_COMP_PROPERTY_SEARCH_START';
export const VERSION_COMP_PROPERTY_SEARCH_SUCCESS =
  'VERSION/VERSION_COMP_PROPERTY_SEARCH_SUCCESS';
export const VERSION_COMP_PROPERTY_SEARCH_ERROR =
  'VERSION/VERSION_COMP_PROPERTY_SEARCH_ERROR';

export const VERSION_COMP_PROPERTY_SELECT_START =
  'VERSION/VERSION_COMP_PROPERTY_SELECT_START';
export const VERSION_COMP_PROPERTY_SELECT_SUCCESS =
  'VERSION/VERSION_COMP_PROPERTY_SELECT_SUCCESS';
export const VERSION_COMP_PROPERTY_SELECT_ERROR =
  'VERSION/VERSION_COMP_PROPERTY_SELECT_ERROR';

export const VERSION_DESCRIPTION_UPDATE_START =
  'VERSION/VERSION_DESCRIPTION_UPDATE_START';
export const VERSION_DESCRIPTION_UPDATE_SUCCESS =
  'VERSION/VERSION_DESCRIPTION_UPDATE_SUCCESS';
export const VERSION_DESCRIPTION_UPDATE_ERROR =
  'VERSION/VERSION_DESCRIPTION_UPDATE_ERROR';

export const VERSION_COMP_SELECT_PROPERTY =
  'VERSION/VERSION_COMP_SELECT_PROPERTY';

export const VERSION_COMP_PROPERTY_CHANGE_CURRENT_PAGE =
  'VERSION/VERSION_COMP_PROPERTY_CHANGE_CURRENT_PAGE';
export const VERSION_COMP_PROPERTY_CHANGE_SORT_MODEL =
  'VERSION/VERSION_COMP_PROPERTY_CHANGE_SORT_MODEL';
export const VERSION_COMP_PROPERTY_CHANGE_PAGE_SIZE =
  'VERSION/VERSION_COMP_PROPERTY_CHANGE_PAGE_SIZE';
export const VERSION_COMP_PROPERTY_SET_SEARCH_RULE =
  'VERSION/VERSION_COMP_PROPERTY_SET_SEARCH_RULE';
export const VERSION_COMP_PROPERTY_REMOVE_SEARCH_RULE =
  'VERSION/VERSION_COMP_PROPERTY_REMOVE_SEARCH_RULE';
export const VERSION_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE =
  'VERSION/VERSION_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE';

export const fetchVersionList = makeApiActionCreatorV3(
  api.fetchVersionList,
  VERSIONS_FETCH_START,
  VERSIONS_FETCH_SUCCESS,
  VERSIONS_FETCH_ERROR,
);
export const fetchVersion = makeApiActionCreatorV3(
  api.fetchVersion,
  VERSION_FETCH_START,
  VERSION_FETCH_SUCCESS,
  VERSION_FETCH_ERROR,
);
export const createVersion = makeApiActionCreatorV3(
  api.createVersion,
  VERSION_CREATE_START,
  VERSION_CREATE_SUCCESS,
  VERSION_CREATE_ERROR,
);
export const removeVersion = makeApiActionCreatorV3(
  api.removeVersion,
  VERSION_REMOVE_START,
  VERSION_REMOVE_SUCCESS,
  VERSION_REMOVE_ERROR,
);
export const setVersionActive = makeApiActionCreatorV3(
  api.setVersionActive,
  VERSION_SET_ACTIVE_START,
  VERSION_SET_ACTIVE_SUCCESS,
  VERSION_SET_ACTIVE_ERROR,
);
export const addPropertyToVersion = makeApiActionCreatorV3(
  api.addPropertyToVersion,
  VERSION_ADD_PROPERTY_START,
  VERSION_ADD_PROPERTY_SUCCESS,
  VERSION_ADD_PROPERTY_ERROR,
);
export const copyPropertyToVersion = makeApiActionCreatorV3(
  api.copyPropertyToVersion,
  VERSION_COPY_PROPERTY_START,
  VERSION_COPY_PROPERTY_SUCCESS,
  VERSION_COPY_PROPERTY_ERROR,
);
export const importPropertyToVersion = makeApiActionCreatorV3(
  api.importPropertyToVersion,
  VERSION_IMPORT_PROPERTY_START,
  VERSION_IMPORT_PROPERTY_SUCCESS,
  VERSION_IMPORT_PROPERTY_ERROR,
);
export const removePropertyFromVersion = makeApiActionCreatorV3(
  api.removePropertyFromVersion,
  VERSION_REMOVE_PROPERTY_START,
  VERSION_REMOVE_PROPERTY_SUCCESS,
  VERSION_REMOVE_PROPERTY_ERROR,
);
export const searchVersionCompProperty = makeApiActionCreatorV3(
  propertyApi.searchProperty,
  VERSION_COMP_PROPERTY_SEARCH_START,
  VERSION_COMP_PROPERTY_SEARCH_SUCCESS,
  VERSION_COMP_PROPERTY_SEARCH_ERROR,
);
export const versionCompPropertiesSelect = makeApiActionCreatorV3(
  api.versionCompPropertiesSelect,
  VERSION_COMP_PROPERTY_SELECT_START,
  VERSION_COMP_PROPERTY_SELECT_SUCCESS,
  VERSION_COMP_PROPERTY_SELECT_ERROR,
);
export const updateVersionDescription = makeApiActionCreatorV3(
  api.updateVersionDescription,
  VERSION_DESCRIPTION_UPDATE_START,
  VERSION_DESCRIPTION_UPDATE_SUCCESS,
  VERSION_DESCRIPTION_UPDATE_ERROR,
);

export function changeVersionCompCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: VERSION_COMP_PROPERTY_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeVersionCompSortModel(model) {
  return async dispatch => {
    dispatch({ type: VERSION_COMP_PROPERTY_CHANGE_SORT_MODEL, data: model });
  };
}

export function changeVersionCompPageSize(page) {
  return async dispatch => {
    dispatch({ type: VERSION_COMP_PROPERTY_CHANGE_PAGE_SIZE, data: page });
  };
}

export function setVersionCompRule(ruleName, ruleValue) {
  return async dispatch => {
    dispatch({
      type: VERSION_COMP_PROPERTY_SET_SEARCH_RULE,
      data: { ruleName, ruleValue },
    });
  };
}

export function removeVersionCompRule(ruleName) {
  return async dispatch => {
    dispatch({
      type: VERSION_COMP_PROPERTY_REMOVE_SEARCH_RULE,
      data: { ruleName },
    });
  };
}

export function removeAllVersionCompRule() {
  return async dispatch => {
    dispatch({ type: VERSION_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE });
  };
}

export function selectVersionCompProperty(propIds) {
  return async dispatch => {
    dispatch({ type: VERSION_COMP_SELECT_PROPERTY, data: propIds });
  };
}
